import { render, staticRenderFns } from "./lubo.vue?vue&type=template&id=549f7f6a&scoped=true&"
import script from "./lubo.vue?vue&type=script&lang=js&"
export * from "./lubo.vue?vue&type=script&lang=js&"
import style0 from "./lubo.vue?vue&type=style&index=0&id=549f7f6a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549f7f6a",
  null
  
)

export default component.exports